/*! StartNoStringValidationRegion (constants for browser names) */
export enum BrowserName {
  Chrome = "Chrome",
  Firefox = "Firefox",
  Safari = "Safari",
}
/*! EndNoStringValidationRegion */
